import { Skeleton } from "@/app/admin/_common/ui/skeleton";

export default function AutomationDetailSkeleton() {
  return (
    <div className="flex flex-col gap-4">
      {/* Four stat tiles, matching AutomationStatTiles */}
      <div className="grid grid-cols-2 gap-2.5 sm:grid-cols-4">
        {Array.from({ length: 4 }).map((_, i) => (
          <div key={i} className="rounded-md border border-border bg-card p-3.5">
            <Skeleton className="mb-2 h-3 w-16" />
            <Skeleton className="h-5 w-10" />
          </div>
        ))}
      </div>

      {/* Kill switch bar */}
      <div className="flex items-center gap-4 rounded-md border border-border bg-card px-4 py-3">
        <div className="flex flex-1 flex-col gap-1.5">
          <Skeleton className="h-3.5 w-40" />
          <Skeleton className="h-3 w-64" />
        </div>
        <Skeleton className="h-[30px] w-[120px] rounded-md" />
        <Skeleton className="h-5 w-10 rounded-full" />
      </div>

      {/* Setup sections */}
      {Array.from({ length: 3 }).map((_, i) => (
        <div key={i} className="flex flex-col gap-3 rounded-md border border-border bg-card p-4">
          <Skeleton className="h-3.5 w-24" />
          <Skeleton className="h-3 w-56" />
          <Skeleton className="h-[30px] w-[420px] max-w-full rounded-md" />
        </div>
      ))}
    </div>
  );
}
